import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
import BlockCollection from "@/assets/js/models/blocks/BlockCollection";
import StoreLayout from "@/assets/js/models/store/storeLayout/StoreLayout";
var _attributes = /*#__PURE__*/new WeakMap();
export default class StoreLayoutI18n extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [StoreLayoutI18n.id_attribute_name]: null,
      [StoreLayoutI18n.store_layout_attribute_name]: StoreLayout,
      [StoreLayoutI18n.language_attribute_name]: null,
      [StoreLayoutI18n.blocks_attribute_name]: BlockCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getLanguages() {
    return [this.ENGLISH_SHORT_LANGUAGE, this.FRENCH_SHORT_LANGUAGE, this.ITALIAN_SHORT_LANGUAGE, this.SPANISH_SHORT_LANGUAGE, this.ARABIC_SHORT_LANGUAGE];
  }
  static getIdAttributeName() {
    return StoreLayoutI18n.id_attribute_name;
  }
  static getStoreLayoutAttributeName() {
    return StoreLayoutI18n.store_layout_attribute_name;
  }
  static getBlocksAttributeName() {
    return StoreLayoutI18n.blocks_attribute_name;
  }
  static getLanguageAttributeName() {
    return StoreLayoutI18n.language_attribute_name;
  }
  getLanguage() {
    return this.getAttribute(StoreLayoutI18n.getLanguageAttributeName());
  }
  getBlocks() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(StoreLayoutI18n.getBlocksAttributeName())) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
}
_defineProperty(StoreLayoutI18n, "ENGLISH_SHORT_LANGUAGE", 'en');
_defineProperty(StoreLayoutI18n, "ARABIC_SHORT_LANGUAGE", 'ar');
_defineProperty(StoreLayoutI18n, "FRENCH_SHORT_LANGUAGE", 'fr');
_defineProperty(StoreLayoutI18n, "SPANISH_SHORT_LANGUAGE", 'es');
_defineProperty(StoreLayoutI18n, "ITALIAN_SHORT_LANGUAGE", 'it');
_defineProperty(StoreLayoutI18n, "id_attribute_name", 'id');
_defineProperty(StoreLayoutI18n, "store_layout_attribute_name", 'store_layout');
_defineProperty(StoreLayoutI18n, "language_attribute_name", 'language');
_defineProperty(StoreLayoutI18n, "blocks_attribute_name", 'blocks');